export default function EFGlobal(props: any) {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Where-to-Buy_02" transform="translate(-176.000000, -595.000000)">
                    <g id="编组-11" transform="translate(160.000000, 430.000000)">
                        <g id="编组-2备份-4" transform="translate(16.000000, 165.000000)">
                            <rect id="矩形" x="0" y="0" width="20" height="20"></rect>
                            <g id="编组" transform="translate(2.000000, 2.000000)" stroke="#757575" strokeLinecap="round" strokeLinejoin="round">
                                <path
                                    d="M8,16 C12.41828,16 16,12.41828 16,8 C16,3.58172 12.41828,0 8,0 C3.58172,0 0,3.58172 0,8 C0,12.41828 3.58172,16 8,16 Z"
                                    id="路径"
                                ></path>
                                <line x1="0" y1="8" x2="16" y2="8" id="路径"></line>
                                <path
                                    d="M8,16 C9.76732,16 11.2,12.41828 11.2,8 C11.2,3.58172 9.76732,0 8,0 C6.23268,0 4.8,3.58172 4.8,8 C4.8,12.41828 6.23268,16 8,16 Z"
                                    id="路径"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
